import { PageType, PageTypes, SubUseCase, UseCase } from 'strapi/page/types';
import { RequestParams } from 'strapi/types';

import { RelatedLinksStrapiComponent } from './types';

export const relatedLinksComponentParams: (type: PageType) => RequestParams<
  | (PageTypes & {
      relatedLinks: RelatedLinksStrapiComponent;
      use_case: UseCase;
    })
  | {
      relatedLinks: RelatedLinksStrapiComponent;
      sub_use_case: SubUseCase;
    }
> = (type: PageType) => {
  let populateLinks = {};

  if (type === PageType.CreateUseCasePage) {
    populateLinks = {
      use_case: {
        populate: {
          sub_use_cases: {
            populate: {
              create_sub_use_case_page: { fields: ['path'] },
            },
          },
        },
      },
    };
  }
  if (type === PageType.CreateSubUseCasePage) {
    populateLinks = {
      sub_use_case: {
        populate: {
          use_case: {
            populate: {
              sub_use_cases: {
                populate: {
                  create_sub_use_case_page: { fields: ['path'] },
                },
              },
            },
          },
        },
      },
    };
  }

  if (type === PageType.MockupChildPage) {
    populateLinks = {
      mockup_parent_page: {
        populate: {
          mockup_child_pages: {
            fields: ['path', 'slug', 'descriptiveName'],
          },
        },
      },
    };
  }

  if (type === PageType.AiWritingToolChildPage) {
    populateLinks = {
      ai_writing_parent_page: {
        populate: {
          ai_writing_child_pages: {
            fields: ['path', 'slug', 'descriptiveName'],
          },
        },
      },
    };
  }

  return {
    populate: {
      relatedLinks: {
        populate: {
          extraLinks: true,
        },
      },
      ...populateLinks,
    },
  };
};
